import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../../../context/AuthContext";

const SSOHandler = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useAuth();

    useEffect(() => {
        const hash = location.hash.replace("#", "");
        const params = new URLSearchParams(hash);

        // ToDo: Cognito - disable
        const s_t = params.get("s_t");
        // const a_t = params.get("a_t");
        // const r_t = params.get("r_t");

        // if (!a_t || !r_t) {
        if (!s_t) {
            navigate("/login", { replace: true });
            return;
        }

        const run = async () => {
            try {
                await login({
                    session_token: s_t,
                });
                // await login({
                //     auth_token: a_t,
                //     auth_refresh_token: r_t,
                // });

                navigate("/", { replace: true });
            } catch (err) {
                console.error("SSO failed", err);
                navigate("/login", { replace: true });
            }
        };

        run();
    }, [location.hash]);

    return <div>Signing you in...</div>;
};

export default SSOHandler;
